import React from 'react';
import { Section } from './Section';
import { CheckCircle2 } from 'lucide-react';
export function IdentificationSection() {
  const bullets = ['te inflamas con facilidad', 'sientes retención o pesadez durante el día', 'quieres sentirte más ligera sin dietas extremas', 'necesitas una guía simple y clara en español', 'quieres empezar hoy con pasos prácticos'];
  return <Section className="bg-sage" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <h2 className="font-serif text-3xl md:text-4xl text-forest font-bold mb-8 text-center" data-id="element-105">
          Si te sientes hinchada, pesada o incómoda con tu abdomen, esta guía es
          para ti
        </h2>

        <div className="bg-white rounded-2xl p-8 md:p-10 shadow-xl border border-sage-dark mb-8" data-id="element-106">
          <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-107">
            Hay días en los que amaneces bien, pero conforme pasan las horas
            sientes el abdomen más duro, la ropa más ajustada y el cuerpo más
            pesado.
          </p>
          <p className="text-gray-700 text-lg leading-relaxed font-medium" data-id="element-108">
            No es solo una cuestión estética. Es esa incomodidad constante que
            te quita energía, te frustra frente al espejo y hace que sientas que
            nada de lo que intentas te funciona de verdad.
          </p>
        </div>

        <div className="bg-cream p-8 rounded-2xl border border-cream-dark" data-id="element-109">
          <h3 className="font-serif text-2xl font-bold text-forest mb-6" data-id="element-110">
            Esta guía es ideal para ti si:
          </h3>
          <ul className="space-y-4" data-id="element-111">
            {bullets.map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-112">
                <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0 mt-0.5" data-id="element-113" />
                <span className="text-gray-800 text-lg" data-id="element-114">{item}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}